module.exports = __webpack_public_path__ + "static/media/91.5c0d8306.png";